import React, { useContext, useEffect, useState } from 'react'
import { VehicleContext } from '../../Context/VehicleContext';
import { getImages, teamImages } from '../../Common/const';

const departments = ['Sales', 'Service', 'Detail', 'Marketing'];
// , 'Accounting & Titling', 'Detailing', 'Mark Customs'

const TeamMembers = () => {
    const { getTeamMembers } = useContext(VehicleContext);
    const [teamMembers, setTeamMembers] = useState([]);
    const fetchTeamMembers = async () => {
        const data = await getTeamMembers();
        console.log(data);
        setTeamMembers(data);
    }
    useEffect(() => {
        fetchTeamMembers();
    }, []);

    const [isMobile, setIsMobile] = useState(window.innerWidth < 767);


    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    const locations = [
        ...new Set(
            teamMembers.map(item => item.location?.split('_')[0])
        )
    ];
    return (
        <>
            {locations.map((location, locIndex) => {

                // Filter team by location
                const locationTeam = teamMembers.filter(
                    item => item.location === location
                );

                if (locationTeam.length === 0) return null;

                return (
                    <div key={locIndex}>
                        <h2 className="lg-title text-uppercase fw-700 text-orange ">
                            {location}
                        </h2>

                        <div className="accordion team-accordion" id={`accordion-${locIndex}`}>

                            {departments.map((category, idx) => {

                                // Filter by department INSIDE that location
                                const teamList = locationTeam.filter(
                                    item => item.department === category
                                );

                                if (teamList.length === 0) return null;

                                const collapseId = `collapse-${locIndex}-${idx}`;

                                return (
                                    <div className="accordion-item" key={idx}>
                                        <h2 className="accordion-header wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.3s">
                                            <button
                                                className={`accordion-button text-uppercase ps-5  ${isMobile && idx !== 0 ? '' : ''}`}
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target={`#${collapseId}`}
                                            >
                                                {category} Department
                                            </button>
                                        </h2>

                                        <div
                                            id={collapseId}
                                            className={`accordion-collapse collapse ${isMobile ? idx === 0 ? 'show' : 'show' : 'show'}`}
                                            {...(isMobile ? { 'data-bs-parent': '#accordionExample' } : {})}
                                        >
                                            <div className="accordion-body">
                                                <div className="d-md-flex flex-wrap team-flex">

                                                    {teamList.map((item, index) => (
                                                        <div className="team-col" key={index}>
                                                            <div className="team-box w-100">
                                                                <div className="team-image">
                                                                    <img
                                                                        src={item.photo_url || teamImages('./no-photo.png')}
                                                                        alt={item.full_name}
                                                                    />
                                                                </div>

                                                                <div className="team-content">
                                                                    <div className="team-title1 text-white text-uppercase mb-1">
                                                                        {item.full_name}
                                                                    </div>
                                                                    <div className="team-title2 text-white opacity-0-5 mb-2">
                                                                        {item.position}
                                                                    </div>
                                                                    <div className='text-center mt-2 px-md-3'>
                                                                        {item.phone && (
                                                                            <a href={`tel:${item.phone}`} className="pe-2 me-1">
                                                                            <img src={getImages('team_phone.png')} alt="call" />
                                                                            </a>
                                                                        )}
                                                                        {item.email && (
                                                                            <a href={`mailto:${item.email}`} className="px-2 me-1">
                                                                            <img src={getImages('team_email.png')} alt="email" />
                                                                            </a>
                                                                        )}
                                                                        <a href="#" className="ps-2 me-1">
                                                                            <img src={getImages('team_info.png')} alt="info" />
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}

                        </div>
                    </div>
                );
            })}
        </>
    )
}

export default TeamMembers